<template>
  <div class="htDetails full-height">
    <img
      class="custom-back"
      @click="path ? $router.push({ path: path }) : $router.go(-1)"
      src="~Assets/images/back.png"
      alt="返回"
    >
    <mescroll-vue
      ref="mescroll"
      :down="{use:false}"
    >
      <div class="custom-van-swipe">
        <van-swipe @change="index => (van_swipe.current = index)">
          <van-swipe-item
            class="custom-imgbox"
            v-for="(image, index) in van_swipe.images"
            :key="index"
          >
            <img v-lazy="image">
          </van-swipe-item>

          <div
            class="custom-indicator"
            slot="indicator"
            @click="imagePreview(van_swipe.images, van_swipe.current)"
          >
            <ld-icon
              type="iconpicture"
              class="vertical-middle"
            />
            <span>{{ van_swipe.current + 1 }}/{{ van_swipe.images && van_swipe.images.length }}</span>
          </div>
        </van-swipe>
      </div>
      <van-skeleton
        :row="4"
        :loading="loading"
        class="pd10"
        style="background: #fff;"
      >
        <div
          class="base-info custom-active-bg"
          @click="$router.push('/ht/htQuery/htMore')"
        >
          <div class="content-box">
            <div class="title-box">
              <h1 style="line-height: 16px;">
                {{ data_.jdmc }}
                <span style="font-size: 12px; font-weight: normal;">{{ data_.jden }}</span>
                <span v-if="data_.starRate == '5'">
                  <span class="label">豪华型</span>
                  <img
                    class="pic"
                    src="~Assets/images/ht/hotel_type_03.png"
                  >
                </span>
                <span v-if="data_.starRate == '4'">
                  <span class="label">高档型</span>
                  <img
                    class="pic"
                    src="~Assets/images/ht/hotel_type_01.png"
                  >
                </span>
                <span v-if="data_.starRate == '3'">
                  <span class="label">舒适型</span>
                  <img
                    class="pic"
                    src="~Assets/images/ht/hotel_type_02.png"
                  >
                </span>
                <span v-if="data_.starRate == '0' || data_.starRate == '1' || data_.starRate == '2'">
                  <span class="label">经济型</span>
                </span>
              </h1>
            </div>
            <div class="score-box">
              <!-- <span class="desc">
              {{ data_.renovationDate ? (data_.renovationDate + ' 装修') : '' }} {{ data_.establishmentDate ? (data_.establishmentDate + ' 开业') : '' }}
            </span> -->
              <span class="num-box">
                <strong class="num">{{ data_.score }}</strong>分
              </span>
            </div>
          </div>
          <ld-icon type="iconright right-pic" />
        </div>

        <van-row
          type="flex"
          class="loca-box"
          align="bottom"
          @click="$router.push({ path: '/ht/htQuery/htMap', query: { lon: data_.googleLon, lat: data_.googleLat }})"
        >
          <van-col span="17">
            <ld-icon
              type="iconlocation"
              size="16"
              class="gray"
            />&nbsp;
            <span class="font12">
              <span class="font-bold">{{ data_.address }}</span> <br>
              {{ data_.districtname ? data_.districtname : '' }}
              {{ data_.businessZonename ? (' / ' + data_.businessZonename) : '' }}
            </span>
          </van-col>
          <van-col
            class="main-color font12 text-right"
            offset="1"
            span="6"
          >
            地图/周边
            <van-icon
              name="arrow"
              class="gray vertical-middle"
              size="20"
            />
          </van-col>
        </van-row>
      </van-skeleton>
      <div class="inquiry-box custom-active-bg mb5">
        <div
          class="inquiry bg-lightYellow Grid"
          @click="$router.push({path: '/ht/htQuery/htInquiry', query: {jdid: $route.query.jdid}})"
        >
          <div class="pd5-10">
            <a class="inquiry-title main-color font18">线上询价</a>
          </div>
          <div class="Grid-cell">
            <p class="mt10">
              人工询价，直通酒店前台预订
            </p>
            <p>线下比价，找出市场最优资源</p>
          </div>
          <div class="pd5-10">
            <a class="inquiry-btn bg-main"><span>立即询价</span></a>
          </div>
        </div>
      </div>

      <!-- <div
        class="Grid grid--1of2 mb5 pd12-28 bg-white"
      >
        <div
          class="Grid-cell text-left"
          @click="$refs['htContactRoom'].toggle()"
        >
          每间入住 <span class="main-color">{{ model._conditions.adultPopulation }}成人{{ model._conditions.childrenNumber }}儿童/{{ model._conditions.roomCount }}间</span>
        </div>
        <div
          class="Grid-cell text-right"
          @click="$refs['nation'].toggle()"
        >
          入住人国籍 <span class="main-color">{{ model._nationality.code }}</span>
        </div>
      </div> -->
      <div class="Grid mb5 pd12-10 bg-white van-hairline--bottom">
        <div class="Grid-cell">
          <div
            class="Grid Grid--1of3 query-info__date"
            @click="showDate"
          >
            <div class="Grid-cell text-center">
              <div class="Grid-cell--autoSize font12">
                {{ $t('H006','入住日期') }}
              </div>
              <div class="Grid-cell--autoSize query-info__date--weight font12 main-color">
                {{ model._checkInDate.monDay }}&nbsp;<span class="font-normal">{{ model._checkInDate.week }}</span>
              </div>
            </div>
            <div class="Grid-cell Grid-cell--center text-center font12">
              <span class="date-num">{{ $t('E017','共') }}<span class="query-info__tips--color">{{ model._days }}</span>晚</span>
              <div class="arrow-line arrow-line--white" />
            </div>
            <div class="Grid-cell text-center">
              <div class="Grid-cell--autoSize font12">
                {{ $t('H007','离店日期') }}
              </div>
              <div class="Grid-cell--autoSize query-info__date--weight font12 main-color">
                {{ model._checkOutDate.monDay }}&nbsp;<span class="font-normal">{{ model._checkOutDate.week }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="ml10 van-clearfix"
          @click="$refs['htContactRoom'].toggle()"
        >
          <span
            class="c999 fl w30"
            style="margin-top: -2px; font-size: 11px;"
          >每间入住</span>
          <div
            class="fr"
            style="margin-top: -6px;"
          >
            <p>{{ model._conditions.adultPopulation }}{{ $t('C115','成人') }}</p>
            <p>{{ model._conditions.childrenNumber }}儿童</p>
          </div>
        </div>
      </div>

      <van-skeleton
        avatar
        :row="3"
        :loading="loading"
        avatar-size="74"
        class="pd10"
        style="background: #fff;"
      >
        <div class="items-content-box">
          <div
            class="text-center pd10"
            v-if="data_.hotelRoom && !data_.hotelRoom.length"
          >
            <img
              style="width: 60%;"
              src="~/Assets/images/ht/no_room.png"
            >
            <p class="cccc">
              没有查询到符合条件的房间！
            </p>
            <p class="cccc">
              请选择其它酒店或者修改日期和人数重新查询。
            </p>
          </div>
          <div
            class="items-box"
            v-for="(item, index) in data_.hotelRoom || []"
            :key="index"
          >
            <div class="items-box-padding custom-active-bg">
              <div class="items-box-border">
                <div class="item-img custom-imgbox">
                  <img
                    class="list-item-img"
                    v-lazy="item.roomImgUrl"
                    @click="popupAssignment(item)"
                  >
                </div>
                <div
                  class="item-info"
                  @click="item.visible = !item.visible"
                >
                  <h3>{{ item.roomName }}</h3>
                  <ul class="van-clearfix">
                    <li>{{ item.roomEnName }}</li>
                  </ul>
                  <!-- 预留，可通过查看hotelRoom.js中的 *htQuery/hotelRoom 配置信息 -->
                  <p class="explain" />
                  <p class="cash">
                    <span>
                      <strong>{{ item.minFacePrice }}</strong>
                      <span class="font12">{{ item.ratePlans[0].currency | currencyType }}</span>
                    </span>{{ $t('rise','起') }}
                  </p>
                </div>
                <ld-icon
                  class="animation-status"
                  :class="item.visible ? 'active' : ''"
                  type="icondown more"
                  @click="item.visible = !item.visible"
                />
              </div>
            </div>
            <div class="van-slide-down-box">
              <transition name="van-slide-down">
                <div
                  class="sub-box"
                  v-show="item.visible"
                >
                  <div
                    class="sub-item custom-active-bg"
                    v-for="(i, index_) in item.ratePlans"
                    :key="index_"
                  >
                    <div
                      class="sub-item-info"
                      @click="openCanPopup(item, i)"
                    >
                      <p class="name">
                        {{ i.rpName }} {{ i.rpEnName }}
                        <span
                          v-if="i.remains < 3"
                          class="label bg_ff5655"
                        >{{ $t('jz','紧张') }}</span>
                        <span
                          v-if="i.remains == 0"
                          class="label bg_3196fb"
                        >售罄</span>
                      <!--
                        是否违背需要根据如下几种情况综合判断，满足其中之一即为违背
                        1、因公出行 && 第一晚的房间价格是否超出了[当前登录人/选择的出行人/多个出行人按差标等级最低的进行匹配]差旅标准规定的房间价格(超过即为违背)
                        2、因公出行 && 差旅标准的管控方式为1[1: 只做提醒 2: 不允许预订] && 出差申请单模式 && (第一晚的房间价格 - 费用预算 / 房间数) > 0 大于0即为违背
                      -->
                      <!-- <span
                        class="wei"
                        v-if="pageCtrl.isStart && model._policy.jdjgbz && (model.tripType == 1 && i.firstPrice - model._policy.jdjgbz > 0) || (model._policy.gkfs && model.tripType == 1 && model._policy.gkfs == 1 && model._ccsqPattern.checked && (i.firstPrice - model._ccsqPattern.fyys / model._ccsqPattern.fjs) > 0)"
                      >违</span> -->
                      </p>
                      <p class="contain">
                        <span v-if="!i.numBreakfasts">{{ $t('H029','不含早') }}</span>
                        <span v-else>含{{ i.numBreakfasts }}份早餐</span>
                      </p>
                      <p class="guarantee">
                        <a v-if="i.cancelType == 1">{{ $t('H033','不可取消') }}</a>
                        <a v-if="i.cancelType == 2">限时免费取消</a>
                        <a v-if="i.cancelType == 3">限时收费取消</a>
                        <a v-if="i.cancelType == 4">{{ $t('H069','免费取消') }}<</a>
                      </p>
                      <p class="cash">
                        <strong>{{ i.firstPrice }}</strong>
                        <span class="font12">{{ i.currency | currencyType }}</span>
                      </p>
                    </div>
                    <!--
                    能否预订酒店需要根据下面条件综合判断
                    1、因私出行可预订
                    2、因公出行 && 第一晚的房间价格是否超出了[当前登录人/选择的出行人/多个出行人按差标等级最低的进行匹配]差旅标准规定的房间价格 [超出不可预订] && 差旅标准的管控方式为2[1: 只做提醒 2: 不允许预订]
                    3、差旅标准的管控方式为1[1: 只做提醒 2: 不允许预订]

                    注：添加class类 [no] 按钮不可点击状态
                  -->

                    <!-- <a
                    class="book-btn linear-main1"
                    v-if="i.allRoomStatus != 3 && pageCtrl.isStart"
                    :class="(!model._policy.id || model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1) ? '' : 'no'"
                    @click="(!model._policy.id || model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1) && book(i)"
                  >
                    <p>订</p>
                    <span
                      v-if="(model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1)"
                      :style="{color: '#ff4f3f'}"
                    >预付</span>
                    <span
                      v-if="!(model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1)"
                      class="c999"
                    >预付</span>
                  </a> -->
                    <!-- v-if="i.allRoomStatus != 3 && !pageCtrl.isStart" -->
                    <a
                      class="book-btn linear-main1"
                      @click="book(i)"
                    >
                      <p>订</p>
                      <!-- <span v-if="(model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1)" :style="{color: i.payment == 1 ? '#181818' : '#ff4f3f'}">{{ i.payment == 1 ? '到店付' : '预付' }}</span>
                    <span v-if="!(model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1)" class="c999">{{ i.payment == 1 ? '到店付' : '预付' }}</span> -->
                      <span :style="{color: '#ff4f3f'}">{{ $t('H030','预付') }}</span>
                    </a>
                    <a
                      class="book-btn no"
                      v-if="i.allRoomStatus == 3"
                    >
                      <p>订</p>
                      <span class="c999">已满房</span>
                    </a>
                  </div>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </van-skeleton>

      <van-popup
        v-model="van_popup.show"
        round
        closeable
        position="bottom"
        :close-on-popstate="true"
        :style="{ 'background-color': '#f6f6f5', 'padding-bottom': '55px' }"
      >
        <div class="custom-van-swipe- custom-van-swipe-box">
          <div class="title">
            {{ van_popup.i.rpName }}
          </div>
          <van-swipe @change="index => (van_popup.item.current = index)">
            <van-swipe-item
              class="custom-imgbox"
              v-for="(image, index) in van_popup.item.roomsImgs"
              :key="index"
            >
              <img v-lazy="image">
            </van-swipe-item>

            <div
              class="custom-indicator"
              slot="indicator"
              @click="imagePreview(van_popup.item.roomsImgs, van_popup.item.current)"
            >
              <ld-icon
                type="iconpicture"
                class="vertical-middle"
              />
              <span>{{ van_popup.item.current + 1 }}/{{ van_popup.item.roomsImgs && van_popup.item.roomsImgs.length }}</span>
            </div>
          </van-swipe>
        </div>
        <div class="items-box-popup popup-items-box mb10 p-b-10">
          <div class="item-info">
            <h3>房型设施</h3>
            <div class="Grid Grid--1of2 item-info-box">
              <div
                class="Grid-cell"
                v-if="van_popup.i.roomSize"
              >
                <span>面积</span>{{ van_popup.i.roomSize }}平米
              </div>
              <div
                class="Grid-cell"
                v-if="van_popup.i.numExtrabeds || van_popup.i.numExtrabeds == 0"
              >
                <span>加床信息</span>
                <span v-if="van_popup.i.numExtrabeds == 0">不可加床</span>
                <span v-if="van_popup.i.numExtrabeds > 0">可加{{ van_popup.i.numExtrabeds }}{{ $t('E305','张') }}床</span>
              </div>
              <div
                class="Grid-cell"
                v-if="van_popup.i.internet || van_popup.i.internet == 1 || van_popup.i.internet == 3"
              >
                <span>网络</span>
                <span v-if="van_popup.i.internet == 1">免费网络</span>
                <span v-if="van_popup.i.internet == 3">付费网络</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="items-box-popup popup-items-box mb10 p-b-10"
          v-if="van_popup.i.bookRemarks"
        >
          <div class="item-info">
            <h3>
              预订规则
            </h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                {{ van_popup.i && van_popup.i.bookRemarks }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="items-box-popup popup-items-box mb10 p-b-10"
          v-if="van_popup.i.cancelPolicyRemarks"
        >
          <div class="item-info">
            <h3>
              <span v-if="van_popup.i.cancelType == 1">{{ $t('H033','不可取消') }}</span>
              <span v-if="van_popup.i.cancelType == 2">限时免费取消</span>
              <span v-if="van_popup.i.cancelType == 3">限时收费取消</span>
              <span v-if="van_popup.i.cancelType == 4">{{ $t('H069','免费取消') }}<</span>
            </h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                {{ van_popup.i && van_popup.i.cancelPolicyRemarks }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="items-box-popup popup-items-box mb10 p-b-10"
          v-if="van_popup.i.promotion"
        >
          <div class="item-info">
            <h3>
              优惠活动
            </h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                {{ van_popup.i && van_popup.i.promotion }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="items-box-popup popup-items-box mb10 p-b-10"
          v-if="van_popup.i && van_popup.i.facilities && van_popup.i.facilities.join(',')"
        >
          <div class="item-info">
            <h3>
              房间设施
            </h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                {{ van_popup.i.facilities.join(',') }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          class="items-box-popup popup-items-box mb10 p-b-10"
          v-if="pageCtrl.isStart && model._policy.jdjgbz && travelerList.length || pageCtrl.isStart && !pageCtrl.showtips && model._policy.jdjgbz"
        >
          <div class="item-info">
            <h3>差旅标准</h3>
            <div class="Grid item-info-cancel">
              <div class="Grid-cell">
                <div>当前标准，不得高于{{ model._policy.jdjgbz }}元/间夜</div>
              </div>
            </div>
          </div>
        </div> -->
        <ld-tabbar
          ref="tabbar"
          :price-list="priceList"
        >
          <van-row
            class="full-width bg-white"
            type="flex"
            align="center"
          >
            <van-col span="1" />
            <van-col span="14">
              <p
                style="font-size: 12px;"
              >
                {{ $t('H030','预付') }}
                <span
                  v-if="van_popup.i.allRoomStatus == 1"
                  class="tabbar-label bgff5655"
                >{{ $t('jz','紧张') }}</span>
                <!-- <span
                  class="wei"
                  v-if="pageCtrl.isStart && model._policy.jdjgbz && (model.tripType == 1 && van_popup.i.firstPrice - model._policy.jdjgbz > 0) || (model._policy.gkfs && model.tripType == 1 && model._policy.gkfs == 1 && model._ccsqPattern.checked && (van_popup.i.firstPrice - model._ccsqPattern.fyys / model._ccsqPattern.fjs) > 0)"
                >违</span> -->
              </p>
              <span class="font12 red">&yen;</span>
              <span
                class="font44 red"
              >
                <strong>
                  {{ van_popup.i.firstPrice }}
                </strong>
              </span>
            </van-col>
            <van-col
              span="8"
              class="pad-r-8"
            >
              <!-- <ld-button
                v-if="van_popup.i.allRoomStatus != 3 && pageCtrl.isStart"
                :loading="isLoading"
                size="md"
                main
                :disabled="(!model._policy.id || model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && van_popup.i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1) ? false : true"
                @click="(!model._policy.id || model.tripType == 2 || (model._policy.jdjgbz && model._policy.gkfs && model.tripType == 1 && van_popup.i.firstPrice - model._policy.jdjgbz <= 0 && model._policy.gkfs == 2) || model._policy.gkfs && model._policy.gkfs == 1) && book(van_popup.i)"
              >
                立即预订
              </ld-button> -->
              <!-- v-if="van_popup.i.allRoomStatus != 3 && !pageCtrl.isStart" -->
              <ld-button

                :loading="isLoading"
                size="md"
                main
                @click="book(van_popup.i)"
              >
                立即预订
              </ld-button>
              <ld-button
                v-if="van_popup.i.allRoomStatus == 3"
                :loading="isLoading"
                size="md"
                main
                disabled
              >
                已满房
              </ld-button>
            </van-col>
            <van-col span="1" />
          </van-row>
        </ld-tabbar>
      </van-popup>

      <div
        class="no-more pd10-0 text-center"
        v-if="data_.hotelRoom && data_.hotelRoom.length"
      >
        没有更多数据了~
      </div>
      <!-- 酒店选择入住/离店日期控件 -->
      <!-- <ld-date
        ref="date"
        @selected="getDate"
        :mode="1"
        init-pre-month-count="3"
        :start-date="model._checkInDate.date"
        :end-date="model._checkOutDate.date"
        :min-date="model._min_date"
        :max-date="model._max_date"
      /> -->

      <Ld-calendar
        ref="date"
        type="range"
        @selected="getDate"
      />
      <!-- 上拉菜单：违背差旅政策 -->
      <!-- <van-action-sheet
        v-model="van_action_sheet.show"
        title="违背差旅政策"
      >
        <div style="padding: 10px 15px;">
          根据贵公司差旅政策规定，您当前选择的舱位违背了
        </div>
        <div style="font-size: 16px; padding: 10px 15px; background: #f9f9f9;">
          违背原因
        </div>
        <van-radio-group v-model="violation">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in violationItems"
              :key="index"
              :title="item.reasonDesc"
              clickable
              @click="violation = item.reasonCode+','+item.reasonDesc"
            >
              <van-radio
                slot="right-icon"
                :name="item.reasonCode+','+item.reasonDesc"
              />
            </van-cell>
            <van-cell
              title="其他原因"
              clickable
              @click="violation = ''"
            >
              <van-radio
                slot="right-icon"
                name=""
              />
            </van-cell>
            <van-cell v-if="violation == ''">
              <input
                style="width: 100%; border: none; outline: none;"
                type="text"
                placeholder="请输入原因"
                v-model="otherReasonDesc"
              >
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <div style="padding: 10px 15px;">
          <a
            style="width: 100%; border-radius: 20px; padding: 10px 0;"
            class="Button linear-main1 Button__linear--current font14"
            @click="violation && selectViolation() || !violation && otherReasonDesc && selectViolation()"
          >{{ $t('B006','确定') }}</a>
        </div>
      </van-action-sheet> -->
    </mescroll-vue>
    <!-- 通过组件方式调用 -->
    <van-image-preview
      ref="imagePreview"
      v-model="van_image_preview.show"
      :images="van_image_preview.images"
      @change="onChange"
      async-close
      class-name="custom-image-preview"
    >
      <div slot="cover">
        <div class="Grid van-image-preview-north">
          <div
            class="Grid-cell text-center"
          >
            {{ ""+van_image_preview.item.roomName+"("+van_image_preview.item.roomEnName+")" }}
          </div>
          <ld-icon
            class="close-icon"
            type="iconclose"
            @click="$refs['imagePreview'].close()"
          />
        </div>
      </div>
    </van-image-preview>

    <!-- 选择入住条件 -->
    <ht-contact-room
      ref="htContactRoom"
      :c="model._conditions"
      @selected="getData"
    />

    <!-- 选择国籍 -->
    <ld-nation
      ref="nation"
      @selected="nationSelect"
    />
  </div>
</template>

<script>
import { Swipe, SwipeItem, ImagePreview, Popup, ActionSheet, Cell, CellGroup, RadioGroup, Radio, Skeleton } from 'vant'
import { formatDate,getDiffDays } from 'Utils/dateUtil'
import { mapState,mapGetters } from 'vuex'
import Vue from 'vue'
import defaultMixin from '../../../../mixins/default'
Vue.use(ImagePreview)

export default {
  name:'HtDetailsInt',
  mixins:[defaultMixin],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [ImagePreview.name]: ImagePreview,
    [Popup.name]: Popup,
    [ActionSheet.name]: ActionSheet,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Skeleton.name]: Skeleton,
    LdCalendar: () => import('Common/ldCalendar'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldTabbar: () => import('Components/ldTabbar/ldTabbar'),
    ldButton: () => import('Common/ldButton'),
    ldNation: () => import('Components/ldNation'),
    /**
     * 选择入住条件
     */
    HtContactRoom: () => import('Views/Ht/htQuery/htContactRoom/index.vue'),
  },
  data() {
    return {
      /**
       * 页面差旅标准对象
       */
      van_swipe: {
        current: 0,
        images: []
      },
      van_image_preview: {
        show: false,
        images: [],
        index: 0,
        item: {}
      },
      // van_action_sheet: {
      // 	show: false
      // },
      van_popup: {
        item: {},
        i: {},
        show: false
      },
      violation: '',
      violationItems: [],
      otherReasonDesc: '',
      priceList: [],
      isLoading: false,
      loading: false,
      path: ''
    }
  },
  computed: {
    ...mapState ({
      model: (state) => state.ht.htSearchInfo,
      /**
       * 酒店详情数据模型
       */
      data_: (state) => state.ht.orderDetails,
      interfacePlat: (state) => state.ht.interfacePlat,
      pageCtrl: (state) => state.ht.pageCtrl
    }),
    ...mapGetters({
      travelerList:'ht/travelerList',
    })
  },
  created () {
    this.$store.commit('ht/orderDetails', {})
    this.loadData()
  },
  methods: {
    /**
     * 初始化酒店详情数据
     */
    loadData() {
      this.loading = true
      this.van_popup.show = false
      // this.van_action_sheet.show = false
      /**
             * 国际酒店获取酒店详情
             */
      this.$api['htQueryInt/hotelInfo']({
        'international': 0,
        'interfacePlatEnum': this.interfacePlat.platId,
        'jdid': this.$route.query.jdid
      }).then(res => {
        /**
                 * 国际酒店获取价格计划列表
                 */
        this.$api['htQueryInt/pricePlanList']({
          'searchPlatZhid': '',
          'searchLocal': 0, // 是否查询本地价格计划 0否 1是 默认1。只针对OSS生效，指定价格计划id查询时无需传入此参数 ,
          'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入 ,
          'tripType': this.model.tripType,
          'cityId': this.model.cityId,
          'interfacePlatId': this.interfacePlat.platId,
          'platHotelId': this.$route.query.jdid,
          'checkInDate': this.model.checkInDate,
          'checkOutDate': this.model.checkOutDate,
          'nationality': this.model._nationality.code,
          'adult': this.model._conditions.model.adultPopulation, // 每间房入住成人数量，最多 10 成人
          'children': this.model._conditions.model.childrenNumber, // 每间房入住的儿童数量，最多 10 儿童
          'childrenAge': this.model._conditions.model.ageItems.join(), // 儿童数量为0时传空字符串；多个儿童年龄时，必须使用半角逗号区分，而且其数量必须和 Children 参数一致，年龄输入范围 0 至 17 岁（包含 0 和 17）
          'roomCount': this.model._conditions.roomCount, // 预定酒店房间数量，最多 5 间
          'ratePlanId': ''
        }).then(res_ => {
          /**
                     * 构建数据模型
                     */
          /**
                     * 将获取到的酒店图片存储到this.van_swipe.images
                     */

          let _images = res.data.detailImgBean && res.data.detailImgBean.hotelImgs && res.data.detailImgBean.hotelImgs[0].url || []
          this.van_swipe.images = _images.length ? _images : ['http://via.placeholder.com/375']
          if (res_.data) {
            res_.data.rooms.forEach(element => {
              element.visible = false
            })
            res.data.hotelRoom = res_.data.rooms
          } else {
            res.data.hotelRoom = []
          }

          this.$store.commit('ht/orderDetails', res.data)
          this.loading = false
        }).catch(() => {})
      }).catch(() => {})
    },
    /**
     * 图片预览操作
     * @param {*} index
     */
    imagePreview(roomsImgs, index) {
      ImagePreview({
        images: roomsImgs,
        startPosition: index
      })
    },
    showDate(){
      if(this.pageCtrl.isChangeDate){
        let maxDate=''
        if(this.model._max_date){
          maxDate=this.model._max_date
        }else{
          maxDate= formatDate(this.model._min_date,90).date
        }
        this.$refs.date.toggle({
          defaultDate:[this.model._checkInDate.date,this.model._checkOutDate.date],
          minDate: this.model._min_date,
          maxDate:maxDate,
        })
      }
    },
    /**
     * 酒店选择入住/离店日期回调
     * @param {*} data
     */
    getDate(data) {
      [this.model.checkInDate,this.model.checkOutDate] = data;
      [this.model._checkInDate,this.model._checkOutDate] = [formatDate(data[0]),formatDate(data[1])]
      this.model._days = getDiffDays(this.model.checkInDate,this.model.checkOutDate)
      /**
             * 重新加载列表
             */
      this.loadData()
    },
    /**
     * 点击房型下的价格计划
     * 为弹出菜单层赋值
     */
    popupAssignment(item) {
      this.van_image_preview.item = item
      this.van_image_preview.show = true
      this.van_image_preview.images = item.roomImgUrl
    },
    /**
     * 预订酒店
     */
    book(i) {
      this.$api['htQueryInt/pricePlanOne']({
        'searchPlatZhid': '',
        'searchLocal': 0, // 是否查询本地价格计划 0否 1是 默认1。只针对OSS生效，指定价格计划id查询时无需传入此参数 ,
        'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入 ,
        'tripType': this.model.tripType,
        'cityId': this.model.cityId,
        'interfacePlatId': this.interfacePlat.platId,
        'platHotelId': this.$route.query.jdid,
        'checkInDate': this.model.checkInDate,
        'checkOutDate': this.model.checkOutDate,
        'nationality': this.model._nationality.code,
        'adult': this.model._conditions.model.adultPopulation, // 每间房入住成人数量，最多 10 成人
        'children': this.model._conditions.model.childrenNumber, // 每间房入住的儿童数量，最多 10 儿童
        'childrenAge': this.model._conditions.model.ageItems.join(), // 儿童数量为0时传空字符串；多个儿童年龄时，必须使用半角逗号区分，而且其数量必须和 Children 参数一致，年龄输入范围 0 至 17 岁（包含 0 和 17）
        'roomCount': this.model._conditions.roomCount, // 预定酒店房间数量，最多 5 间
        'ratePlanId': i.ratePlanId
      }).then(res_ => {
        this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
          _ratePlans: res_.data || i
        }))
        //是否满房
        if (i.allRoomStatus == 2) {
          return this.$toast('您选择的房型已住满，请重新选择！')
        }
        this.$router.push({path:'/ht/htOrderInt'})
      }).catch(() => {})
    },
    // selectViolation() {
    // 	this.$store.commit('ht/orderDetails', Object.assign({}, this.data_, {
    // 		_violation: {
    // 			reasonCode: this.violation ? this.violation.split(',')[0] : '',
    // 			reasonDesc: this.violation ? this.violation.split(',')[1] : this.otherReasonDesc,
    // 			violateitem: '本次预订差旅标准，平均间房不得高于' + this.model._policy.jdjgbz + '元/夜'
    // 		}
    // 	}))
    // 	this.$router.push({path:this.model.path})
    // },
    onChange(index) {
      this.index = index
    },
    openCanPopup(item, i) {
      item.current = 0
      this.van_popup.item = item
      this.van_popup.i = i
      this.van_popup.show = true
    },
    /**
     * 选择国籍回调
     */
    nationSelect(data) {
      this.model._nationality = {
        code: data.by3,
        id: data.id,
        name: data.cName
      }
      this.loadData()
    },
    /**
     * 获取入住人条件
     */
    getData(data) {
      this.model._conditions = data
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped src="../htDetails/index.less"></style>
